import { useEffect } from 'react'
import { useNavigate } from '@tanstack/react-router'
import { useAuth } from '@workos-inc/authkit-react'
import { Card, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'
import { Loader2 } from 'lucide-react'

/**
 * OAuth callback page.
 * AuthKitProvider handles the code exchange automatically.
 * This page just shows a loading state and redirects once authenticated.
 */
export function CallbackPage() {
  const navigate = useNavigate()
  const { user, isLoading } = useAuth()

  useEffect(() => {
    // Once AuthKit has processed the callback and we have a user, redirect
    if (user && !isLoading) {
      navigate({ to: '/dashboard', replace: true })
    }
  }, [user, isLoading, navigate])

  return (
    <div className="flex min-h-screen items-center justify-center bg-background p-4">
      {/* Background elements */}
      <div className="absolute inset-0 bg-gradient-to-br from-background via-background to-primary/5" />
      <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-primary/5 rounded-full blur-3xl" />
      
      <Card className="relative z-10 w-full max-w-md border-border/50 shadow-xl">
        <CardHeader className="text-center space-y-4">
          <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-2xl bg-primary/10">
            <Loader2 className="h-8 w-8 animate-spin text-primary" />
          </div>
          <div className="space-y-2">
            <CardTitle className="text-xl">Signing you in...</CardTitle>
            <CardDescription>Please wait while we complete authentication</CardDescription>
          </div>
        </CardHeader>
      </Card>
    </div>
  )
}
